export default "__VITE_ASSET__VCTGtLYh__"